import { Alert, styled } from '@mui/material';

export const StyledAlert = styled(Alert)(({ theme }) => ({
  maxWidth: '100%',
  paddingRight: 20,
  paddingLeft: 20,
  alignItems: 'center',
  borderRadius: 24,
  '.MuiAlert-message': {
    ...theme.typography.button,
    color: theme.palette.text.primary,
    overflowWrap: 'break-word',
    whiteSpace: 'pre-line',
  },
  '.MuiAlert-icon': {
    marginRight: 20,
    fontSize: '30px',
  },
  '&.MuiAlert-standardSuccess': {
    backgroundColor: theme.palette.background.done,
  },
  '&.MuiAlert-standardWarning': {
    backgroundColor: theme.palette.background.edited,
  },
}));
